import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AppConfig} from '../../../config/app.config';
import {Localization} from '../../common/enums/localization';
import {ApiRouteConfig} from '../../../config/api.route.config';
import {TokenService} from '../../common/services/token.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {Environment} from "../../../environment/environment";

@Component({
  selector: 'app-account-created',
  templateUrl: './account-created.component.html',
  styleUrls: ['./account-created.component.scss']
})
export class AccountCreatedComponent implements OnInit {

  public onboardingUrl: SafeResourceUrl;
  public readonly Localization = Localization;

  constructor(
    public appConfig: AppConfig, 
    private config: ApiRouteConfig, 
    public tokenService: TokenService,
    public sanitizer: DomSanitizer,
    private readonly environment: Environment
  ) { }

  @ViewChild('contentDiv', { read: ElementRef }) contentDiv: ElementRef;

  ngOnInit() {
    const culture =  this.tokenService.getCulture(); 
    const url = this.config.getRouteWithInjectedParams(this.GetOnboardingUrl(), [culture]);
    this.onboardingUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private GetOnboardingUrl(): string {
    let environmentParam = null;
    switch (this.environment.environmentName)
    {
      case 'Dev':
      case 'Local':
        environmentParam = 'Dev';
        break;
      case 'Staging':
        environmentParam = 'St';
        break;
    }
    let onboardingUrl = this.environment.onboardingUrl;
    if(environmentParam)
      onboardingUrl += '&environment=' + environmentParam;
    return onboardingUrl;
  }
}
